export {default as DashboardPage} from './DashboardPage';



// WEBPACK FOOTER //
// ./app/features/dashboard/containers/index.js